import { ReachRow } from "../components/ReachRow"
import type { MetaFunction } from "@remix-run/node"
import { Link } from "@remix-run/react"
import { metadataMapper } from "~/utils/metaMapper"

export const handle = {
  bodyId: "sub",
}

export const meta: MetaFunction = ({ location }) => {
  const title = "About This Outreach | Renewing Your Mind"
  const description =
    "Renewing Your Mind is an outreach of Ligonier Ministries, the international Christian discipleship organization founded in 1971 by Dr. R.C. Sproul."

  const metadata = metadataMapper({
    title,
    description,
    openGraphUrl: `https://renewingyourmind.org${location.pathname}`,
  })
  return metadata
}

export default function About() {
  return (
    <div id="wrapper" className="about">
      <section id="about" className="container">
        <div className="col-100">
          <h1>About This Outreach</h1>
        </div>

        <div className="col-max-66">
          <p className="leadin">
            <em>Renewing Your Mind</em> is an outreach of Ligonier Ministries,
            the international Christian discipleship organization founded in
            1971 by Dr. R.C. Sproul. We know that God uses His Word to change
            lives. In Romans 12:2, the Apostle Paul tells Christians to
            &ldquo;be transformed by the renewal of your mind.&rdquo; That is
            the aim of this podcast and radio broadcast. We&rsquo;re committed
            to faithfully presenting the unvarnished truth of Scripture, helping
            you to know what you believe, why you believe it, how to live it,
            and how to share it.
          </p>
        </div>

        <h2 className="hosts-title">Meet the Hosts</h2>

        <div className="col-max-66 hosts-intro">
          <p>
            Dave Theriault hosts the Monday through Friday episodes of{" "}
            <em>Renewing Your Mind</em>, while Josh Mann hosts the podcast on
            Saturdays and Sundays.
          </p>
        </div>

        <div id="hosts">
          <figure className="col-25" data-testid="host-dave-theriault">
            <img
              src="/images/hosts/dave-theriault.jpg"
              width={150}
              height={150}
              loading="lazy"
              alt=""
            />
            <figcaption>Dave Theriault</figcaption>
          </figure>
          <figure className="col-25" data-testid="host-josh-mann">
            <img
              src="/images/hosts/josh-mann.jpg"
              width={150}
              height={150}
              loading="lazy"
              alt=""
            />
            <figcaption>Josh Mann</figcaption>
          </figure>
        </div>

        <h2 className="label">
          <em>More from Ligonier Ministries</em>
        </h2>
        <nav id="outreaches">
          <Link
            className="col-25"
            to="https://www.ligonier.org"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-ligonier"
          >
            <h3>Ligonier.org</h3>
            <p>
              Watch, read, and listen to a wealth of trusted biblical teaching
            </p>
          </Link>
          <Link
            className="col-25"
            to="https://tabletalkmagazine.com"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-tabletalk"
          >
            <h3>Tabletalk Magazine</h3>
            <p>A monthly discipleship magazine with daily Bible studies</p>
          </Link>
          <Link
            className="col-25"
            to="https://connect.ligonier.org"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-ligonier-connect"
          >
            <h3>Ligonier Connect</h3>
            <p>Online interactive video courses for growing Christians</p>
          </Link>
          <Link
            className="col-25"
            to="https://reformationstudybible.com"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-rsb"
          >
            <h3>The Reformation Study Bible</h3>
            <p>Clear, in-depth commentary for a lifetime of Bible study</p>
          </Link>
          <Link
            className="col-25"
            to="https://refnet.fm"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-refnet"
          >
            <h3>RefNet</h3>
            <p>
              Trustworthy internet radio committed to the historic Christian
              faith
            </p>
          </Link>
          <Link
            className="col-25"
            to="https://www.reformationbiblecollege.org"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-rbc"
          >
            <h3>Reformation Bible College</h3>
            <p>Training the next generation of faithful Christian leaders</p>
          </Link>
          <Link
            className="col-25"
            to="https://www.ligonier.org/events/"
            target="_blank"
            rel="noreferrer"
            data-testid="outreach-ligonier-events"
          >
            <h3>Events</h3>
            <p>
              Gather with others around God&rsquo;s truth in person and online
            </p>
          </Link>
        </nav>
      </section>
      <ReachRow />
    </div>
  )
}
